export default __webpack_public_path__ + "static/media/logo-western-union.2944e42b.png";